declare module 'color-json' {
  function colour(content: string | object): string
  export default colour
}
